import { CURRENT_TRANSACTION_TAB } from "../constants/reduxConstants";

export const setCurrentTabAction = (payload) => {
  return {
    type: CURRENT_TRANSACTION_TAB,
    payload,
  };
};
